import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponseBase,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { tap } from 'rxjs/operators';
import { LoggerHandlerServiceAbstract } from '../abstract/logger-handler-service.abstract';

@Injectable()
export class WrongUrlInterceptor implements HttpInterceptor {

  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: any, private loggerHandler: LoggerHandlerServiceAbstract) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.isBrowser || req.url.includes('logs/log')) {
      return next.handle(req);
    }
    return next.handle(req).pipe(tap(event => {
      if (event instanceof HttpResponse) {
        if (this.isBlockedByNetSec(event)) {
          this.loggerHandler.error.next(`URL [${req.url}] with method [${req.method}] is blocked by netsec. Payload [${JSON.stringify(event.body)}]`);
        }
      }
      if (event instanceof HttpErrorResponse) {
        if (this.isBrowser) {
          if (this.isBlockedByNetSec(event)) {
            this.loggerHandler.error.next(`URL [${req.url}] with method [${req.method}] is blocked by netsec`);
          }
        }
      }
    },
    error => {
      if (this.isBlockedByNetSec(error)) {
        this.loggerHandler.error.next(`URL [${req.url}] with method [${req.method}] is blocked by netsec`);
      }
    }));
  }

  private isBlockedByNetSec(res: HttpResponseBase) {
    return res.status === 202 || res.headers.has('x-netsec-block');
  }
}
